import {
    Voucher_DownloadVoucherURL as download,
    Voucher_UpdateVoucherCustomer as update,
    Voucher_RetriveVoucherCustomer as retrive
} from "./backend"
import axios from 'axios'

const retriveCustomer = async (id, key, idVoucher) => {
    let { data } = await retrive({
        id: id,
        key: key,
        idVoucher: idVoucher,
        $config: {
            _silent: true
        }
    });
    return data;
}

const updateCustomer = async (id, key, idVoucher, customer) => {
    let { data } = await update({
        id: id,
        key: key,
        idVoucher: idVoucher,
        customer: customer
    });
    return data;
}

const  forceFileDownload = (response, pdfName) => {
    const url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute("target", "_blank");
    link.setAttribute('download', `Gutschein_${pdfName}.pdf`) 
    document.body.appendChild(link)
    link.click()
}

const downloadVoucher = async (id, key, idVoucher) => {
    const url = download({
        id: id,
        key: key,
        idVoucher: idVoucher
    });
    const response = await axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
    });
    try {
        forceFileDownload(response, idVoucher);
    } catch(err){
        console.log('error', err)
        window.open(url);
    }


}

export default {
    retriveCustomer,
    updateCustomer,
    downloadVoucher
}